import React from 'react';
import PropTypes from 'prop-types';
import control from '../../hocs/control/index';
//https://github.com/Lesha-spr/react-validation
class Input extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const isIE = false || !!document.documentMode;

    const isEdge = !isIE && !!window.StyleMedia;

    const autoComplete = isEdge ? 'off' : 'on';

    const { error, isUsed, ...props } = this.props;
    let className = '';

    if (isUsed) {
      if (error) {
        className = `is-invalid-input ${props.className}`;
      } else {
        className = `is-valid-input ${props.className}`;
      }
    } else {
      className = `${props.className}`;
    }

    var id = 'vali-' + props.name;

    let { value, defaultValue } = props;

    if (defaultValue && (value === null || value === '')) {
      value = defaultValue;
    }

    return <div className='inputText' style={this.props.divStyle}>
      <input {...props} {...({ className: `${className}` }) } value={value} autoComplete={autoComplete} />
      {isUsed && error && <span id={id} className='cls-danger help-block' style={{marginBottom: -15}}>{error} </span>}
    </div>;
  }
}

Input.propTypes = {
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  name: PropTypes.string,
  isUsed: PropTypes.bool,
  divStyle: PropTypes.object
};

export default control(Input);



// WEBPACK FOOTER //
// ./src/components/react-validation/components/input/index.js